import { createSelector } from 'reselect'

export const getUsers = state => state.get('persist').users

export const getUsersList = createSelector(getUsers, users => users.get('usersList'))

export const getMentionUsersList = createSelector(getUsers, users => users.get('mentionUsers'))
